import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import {
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Chip,
} from "@mui/material";
import { MentionItem } from "../../services/wiki.service";

interface Props {
  items: MentionItem[];
  command: (item: MentionItem) => void;
}

const MentionList = forwardRef<any, Props>(({ items, command }, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => setSelectedIndex(0), [items]);

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }: { event: KeyboardEvent }) => {
      if (event.key === "ArrowUp") {
        setSelectedIndex((i) => (i + items.length - 1) % items.length);
        return true;
      }
      if (event.key === "ArrowDown") {
        setSelectedIndex((i) => (i + 1) % items.length);
        return true;
      }
      if (event.key === "Enter") {
        if (items[selectedIndex]) command(items[selectedIndex]);
        return true;
      }
      return false;
    },
  }));

  if (items.length === 0) return null;

  return (
    <Paper
      elevation={6}
      sx={{ minWidth: 300, maxWidth: 420, maxHeight: 420, overflowY: "auto", overflowX: "hidden" }}
    >
      <List dense disablePadding>
        {items.map((item, index) => (
          <ListItemButton
            key={item.id}
            selected={index === selectedIndex}
            onMouseEnter={() => setSelectedIndex(index)}
            onClick={() => command(item)}
            sx={{ gap: 1, alignItems: "center", py: 1, minWidth: 0, overflow: "hidden" }}
          >
            <ListItemText
              primary={item.label}
              title={item.label}
              sx={{ minWidth: 0, mr: 0.5 }}
              primaryTypographyProps={{
                fontSize: 14.5,
                fontWeight: 500,
                noWrap: true,
                sx: { overflow: "hidden", textOverflow: "ellipsis" },
              }}
            />
            {item.type && (
              <Chip
                label={item.type}
                size="small"
                variant="outlined"
                color={item.type === "contact" || item.type === "client" ? "primary" : "secondary"}
                sx={{ fontSize: 10, height: 20, flexShrink: 0, mt: "2px" }}
              />
            )}
          </ListItemButton>
        ))}
      </List>
    </Paper>
  );
});

MentionList.displayName = "MentionList";
export default MentionList;
